// extracted by mini-css-extract-plugin
export default {"cta":"UG-z","disabled":"VG-z"};